export default __webpack_public_path__ + "static/media/ENDORSE-AD_FHP_BAND_COLOR_.66caa31e.png";